import { SVGProps } from 'react';

function EmailIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <mask id="mask0_2414_1061" style={{ maskType: 'alpha' }} maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="17">
        <rect y="0.5" width="16" height="16" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_2414_1061)">
        <path d="M2.87188 13.5C2.53513 13.5 2.25008 13.3833 2.01675 13.15C1.78341 12.9166 1.66675 12.6316 1.66675 12.2948V4.70513C1.66675 4.36838 1.78341 4.08333 2.01675 3.85C2.25008 3.61667 2.53513 3.5 2.87188 3.5H13.1282C13.465 3.5 13.75 3.61667 13.9834 3.85C14.2167 4.08333 14.3334 4.36838 14.3334 4.70513V12.2948C14.3334 12.6316 14.2167 12.9166 13.9834 13.15C13.75 13.3833 13.465 13.5 13.1282 13.5H2.87188ZM8.00006 8.87175L13.3334 5.4615L13.2308 4.49998L8.00006 7.83332L2.7693 4.49998L2.66673 5.4615L8.00006 8.87175Z" fill="#868991" />
      </g>
    </svg>
  );
}

export default EmailIcon;
